import { AuthFailureCode } from './authorize.service';

/**
 * What a user reads when signing in or out fails (#178).
 *
 * Kept apart from the backend code dictionary on purpose: these are the *client's* own failures,
 * raised by the OIDC library, and they are not in `ErrorCodes`. What they share is the reason for
 * existing — until now the login and logout pages rendered `result.message`, which is whatever was
 * thrown. That is English at best („There was an error signing in."), a raw exception at worst,
 * and on the failure path it travelled through a **query string** on its way to the screen.
 */
export function authFailureText(code: AuthFailureCode | null | undefined): string {
  switch (code) {
    case 'signInCancelled':
      return $localize`:@@auth.signInCancelled:Die Anmeldung wurde abgebrochen.`;
    case 'signInCallbackFailed':
    case 'signInFailed':
      return $localize`:@@auth.signInFailed:Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.`;
    case 'signOutFailed':
      return $localize`:@@auth.signOutFailed:Die Abmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.`;
    default:
      // A code this build does not know — the same rule as the backend dictionary: say
      // something true and general rather than nothing, and never echo what was thrown.
      return $localize`:@@auth.failed:Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`;
  }
}
